import PropTypes from 'prop-types'
import { View } from './View'

/**
 * Appkit4 Paginationコンポーネントは
 * <a href="https://appkit.pwc.com/appkit4/content/pagination?version=react" target="_blank">こちら</a>
 */
export const Pagination = ({ ...props }) => {
    return <View {...props} />
}

Pagination.propTypes = {
    /**
     * トータルのページ数<font color="red">*</font>
     */
    total: PropTypes.number.isRequired,
    /**
     * 現在のページ数<font color="red">*</font>
     */
    current: PropTypes.number.isRequired,
    /**
     * ページ変更時のハンドラー<br>
     * (page: number) => void
     */
    onPageChange: PropTypes.func,
    /**
     * スタイル変更用のクラス名
     */
    className: PropTypes.any
}

Pagination.defaultProps = {
    total: 1,
    current: 1
}
